export default __webpack_public_path__ + "static/media/CapitalBank.22b1e1ab.svg";